import React from "react";

// A playful loader with bouncing stars and a crescent moon
function KidsLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-yellow-50 to-pink-50">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-40 h-40">
          <div className="absolute inset-0 flex items-center justify-center text-6xl animate-pulse">🌙</div>
          <div className="absolute -top-2 left-2 text-2xl animate-bounce" style={{ animationDelay: "0ms" }}>⭐</div>
          <div className="absolute -bottom-1 right-3 text-2xl animate-bounce" style={{ animationDelay: "150ms" }}>⭐</div>
          <div className="absolute top-10 -right-2 text-2xl animate-bounce" style={{ animationDelay: "300ms" }}>⭐</div>
          <div className="absolute bottom-10 -left-2 text-2xl animate-bounce" style={{ animationDelay: "450ms" }}>⭐</div>
        </div>
        <div className="text-yellow-700 font-extrabold text-2xl tracking-wide">
          Loading magic...
        </div>
        <div className="w-48 h-3 bg-white rounded-full shadow-inner overflow-hidden border border-yellow-200">
          <div className="h-full bg-gradient-to-r from-pink-400 to-yellow-300 animate-[loadingbar_1.2s_ease-in-out_infinite]"></div>
        </div>
      </div>
      <style>{`
        @keyframes loadingbar {
          0% { transform: translateX(-100%); width: 30%; }
          50% { transform: translateX(20%); width: 60%; }
          100% { transform: translateX(120%); width: 30%; }
        }
      `}</style>
    </div>
  );
}

export default KidsLoader;


